<script setup lang="ts">
import { ref } from 'vue'
import UiAvatar from './UiAvatar.vue'
import { avatars } from '@/constants'

const modelValue = defineModel<number>()

const root = ref<HTMLElement | null>(null)

const submitFormIfExists = () => root.value?.closest('form')?.requestSubmit()
</script>

<template>
  <div ref="root" class="grid grid-cols-5 justify-items-center gap-3">
    <ui-avatar
      v-for="col in avatars"
      :key="col.id"
      :id="col.id"
      :active="modelValue === col.id"
      :src="col.url"
      tabindex="0"
      role="button"
      class="avatars__avatar"
      @click="modelValue = col.id"
      @keydown.enter="submitFormIfExists"
      @keydown.space="modelValue = col.id"
    />
  </div>
</template>

<style lang="scss">
.avatars {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__avatar {
    display: inline-flex;
    width: 60px;
    height: 60px;
  }
}
</style>
